import { render, staticRenderFns } from "./ProjectInfoView.vue?vue&type=template&id=fcb7e128&scoped=true"
import script from "./ProjectInfoView.vue?vue&type=script&lang=js"
export * from "./ProjectInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb7e128",
  null
  
)

export default component.exports